export default __webpack_public_path__ + "static/media/tatu logo.0bcd4056.png";